import { CalendarIcon, ResourceList, ResourceListItem, ResourceTooltip } from './HeaderResources.style.js';
import { HealthBands, healthBand } from 'model/party/resources/health';
import { ResourceTypes } from 'model/party/resources/resources';
import Tooltip from './Tooltip';

const HeaderResources = ({ resources, phase, calendar }) => {
  const { date, icon, daysLeft } = calendar.format(phase.calendar);

  const { attribs, isVisible } = resources;

  // The header's one piece of hierarchy, and it only exists when it is earned. See health.js for
  // where the bands come from, and HeaderResources.style.js for what each one does to the row.
  const band = healthBand(attribs.health);
  const failing = band !== HealthBands.CLEAR;
  const dying = band === HealthBands.DYING;

  return (
    <ResourceList>
      {Object.keys(attribs).map(key => {
        const resource = attribs[key];
        const shouldAnimate = true;
        const tooltip = resource.tooltip?.();
        const isHealth = resource.index === ResourceTypes.Health;
        return (
          isVisible(phase, resource) &&
          !resource.isCarried && (
            <ResourceListItem
              key={resource.index}
              animate={shouldAnimate}
              $band={isHealth && failing ? band : undefined}
              $dimmed={dying && !isHealth}
            >
              {`${resource.label}: ${resource.value}`}

              {tooltip && (
                <ResourceTooltip>
                  <Tooltip entries={tooltip} />
                </ResourceTooltip>
              )}
            </ResourceListItem>
          )
        );
      })}

      <ResourceListItem $dimmed={dying}>
        {date}
        {daysLeft && <span>{`[${daysLeft} days left]`}</span>}
        <CalendarIcon>{icon}</CalendarIcon>
      </ResourceListItem>
    </ResourceList>
  );
};

export default HeaderResources;
